import { useTranslation } from 'react-i18next';
import { Typography, Stack, useTheme, useMediaQuery } from '@mui/material';
import {
  EmptyAssetsIllustration,
  EmptyAssetsMobileIllustration,
  useFixedHeader,
} from '@diana/core';
import { THINGS_PAGE_NS } from './i18n';

export const ThingsEmpty = () => {
  const { t } = useTranslation(THINGS_PAGE_NS);
  const { breakpoints } = useTheme();
  const isSmallScreen = useMediaQuery(breakpoints.down('md'));
  const { headerOffset } = useFixedHeader();

  return (
    <Stack
      sx={{
        py: 3,
        minHeight: `calc(100vh - ${headerOffset * 2}px)`,
        justifyContent: 'center',
      }}
    >
      <Stack alignItems="center" spacing={8}>
        {isSmallScreen ? (
          <EmptyAssetsMobileIllustration sx={{ maxWidth: 280, height: 'auto' }} />
        ) : (
          <EmptyAssetsIllustration sx={{ maxWidth: 835, height: 'auto' }} />
        )}
        <Stack alignItems="center" spacing={1} sx={{ maxWidth: 466, textAlign: 'center', px: 1 }}>
          <Typography fontSize="1.29rem">{t('empty.title')}</Typography>
          <Typography color="text.secondary">{t('empty.message')}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
